import { IconButton } from "@mui/material";
import { Visibility } from "@mui/icons-material";

export const getColumns = (onViewDetails) => {
  return [
    {
      field: "picker",
      headerName: "Picker",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "date",
      headerName: "Date",
      flex: 0.8,
      minWidth: 120,
    },
    {
      field: "break",
      headerName: "Break",
      flex: 0.7,
      minWidth: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "work",
      headerName: "Work",
      flex: 0.7,
      minWidth: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "work_start",
      headerName: "Work Start",
      flex: 0.8,
      minWidth: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "work_end",
      headerName: "Work End",
      flex: 0.8,
      minWidth: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "total_break",
      headerName: "Total Break Sessions",
      flex: 1,
      minWidth: 150,
      type: "number",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.7,
      minWidth: 100,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => (
        <IconButton
          color="primary"
          onClick={() => onViewDetails(params.row)}
          size="small"
        >
          <Visibility />
        </IconButton>
      ),
    },
  ];
};
